import React from 'react';
import { object, node } from 'prop-types';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import { SubBodyText } from '../Text/Heading';
import RawHTML from '../RawHTML';

import { CheckinIcon, CheckoutIcon } from './DescriptionIcons';

const DescriptionItem = ({ label, content, ...restProps }) => (
  <Wrapper marginTop="24px" {...restProps}>
    <Row>
      <SubBodyText fontWeight="500" color="greyDarker">
        {label}
      </SubBodyText>
    </Row>
    <SubBodyText color="greyDark">
      <RawHTML style={{ lineHeight: '24px' }}>{content}</RawHTML>
    </SubBodyText>
  </Wrapper>
);

DescriptionItem.propTypes = {
  label: node,
  content: node,
};

const ShortPolicies = ({
  checkinDetails = {},
  checkoutDetails = {},
  policies = {},
}) => {
  const { know_before_you_go = '' } = policies;

  const { instructions = '', special_instructions = '' } = checkinDetails;

  return (
    <Wrapper marginBottom="2px">
      {instructions.length > 0 && (
        <>
          <DescriptionItem
            label={
              <>
                <Row className="checkin" alignItems="center">
                  {translate('common.checkinIntroductions')}
                </Row>
                {checkinDetails.time && (
                  <Row className="checkin" alignItems="center">
                    <CheckinIcon />
                    {translate('common.checkIn')}: {checkinDetails.time}
                  </Row>
                )}
                {checkoutDetails.time && (
                  <Row className="checkout" alignItems="center">
                    <CheckoutIcon />
                    {translate('common.checkOut')}: {checkoutDetails.time}
                  </Row>
                )}
              </>
            }
            className="checkin-checkout-policy"
            marginTop={6}
          />
          <DescriptionItem
            content={instructions}
            className="instructions"
            marginTop={4}
          />
        </>
      )}
      {special_instructions.length > 0 && (
        <DescriptionItem
          label={translate('common.specialInstructions')}
          content={special_instructions}
          className="special-instructions"
        />
      )}
      {know_before_you_go && (
        <DescriptionItem
          label={translate('common.knowBeforeYouGo')}
          content={know_before_you_go}
          className="knowledge"
        />
      )}
    </Wrapper>
  );
};

ShortPolicies.propTypes = {
  checkinDetails: object,
  checkoutDetails: object,
  policies: object,
};

export default ShortPolicies;
